import { Toast } from '@amzn/katal-components/es/toast-group';
import { KatToastGroup } from '@amzn/katal-react';
import React, { useState } from 'react';
import styled from 'styled-components';

import { PUB_SUB_EVENT, useSub } from 'src/hooks/usePubSub';
const MessageBannerContainer = styled.div``;

/**
 * This component is responsible to display a generic message
 * @returns
 */
export const MessageBanner = () => {
  const [toastArray, setToastArray] = useState<Toast[]>([]);

  useSub(PUB_SUB_EVENT.SEND_GLOBAL_MESSAGE, (data: Toast) => {
    toastArray.push(data);
    setToastArray([data]);
  });

  return (
    <MessageBannerContainer>
      <KatToastGroup toasts={toastArray}></KatToastGroup>
    </MessageBannerContainer>
  );
};
